import * as React from 'react';
import * as cn from 'classnames';

import * as styles from './arrow.css';

import { trackArrowClick } from '../../../tracking';

interface IProps {
  className?: string;
  style?: object;
  rotated?: boolean;
  slideCount?: number;
  currentSlide?: number;
  onClick?(): void;
}

function handleClickWithAnalytics(cb: (() => void) | undefined) {
  if (cb) {
    cb();
  }

  trackArrowClick();
}

export const Arrow: React.FC<IProps> = ({ className, rotated, style, slideCount, currentSlide, onClick, ...rest }) => {
  return (
    <div className={cn(styles['arrow'], className)} onClick={() => handleClickWithAnalytics(onClick)} {...rest}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        fill="none"
        viewBox="0 0 20 20"
        className={cn(rotated && styles['rotate'])}
      >
        <path fill="#fff" fillOpacity="0.01" d="M20 20H40V40H20z" transform="rotate(0 20 20)" />
        <path
          fill="#0468FF"
          fillRule="evenodd"
          d="M6 14.59L10.945 10 6 5.41 7.522 4 14 10l-6.478 6L6 14.59z"
          clipRule="evenodd"
        />
      </svg>
    </div>
  );
};
